import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import stl from './RecommendationList.module.css';
import { useTranslation } from "@i18n";
import { api__getRecommendedPosts } from "@/apis/posts/recommendation";
import { CDN_LINK } from "@globalConfig";
import { Link } from "react-router-dom";
import { CarCardPlaceHolderGrid } from "@componentsShared/placeholders/CarCardPlaceHolder";
import Layout from "@/_LayoutsRelated/layout/Layout";
import useHelpers from "@hooks/useHelpers";
import { trackEvents } from "@/common/events/events";
import { checkFeatureFlag } from "@/common/config/websiteConfig";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useCookieClient from "@hooks/useCookieClient";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var RecommendationList = function RecommendationList() {
  var _useState = useState([]),
    recommendationPosts = _useState[0],
    setRecommendationPosts = _useState[1];
  var _useState2 = useState(true),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    navigateTo = _useHelpers.navigateTo;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var _useSession = useSession(),
    userData = _useSession.user;
  var userId = getCookieClient("UUID") || null;
  useEffect(function () {
    if (!checkFeatureFlag("FF_RECOMMENDATION_ENABLED")) {
      return;
    }
    if (!userId) {
      setLoading(false);
      return;
    }
    api__getRecommendedPosts(userId, 20).then(function (data) {
      if (data) {
        setRecommendationPosts(_toConsumableArray(data));
        setLoading(false);
      }
    });
    return function () {
      return setRecommendationPosts([]);
    };
  }, [userId]);
  return /*#__PURE__*/React.createElement(Layout, {
    linksForSearch: true,
    authenticationMsg: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true,
    loading: true,
    headHideLinks: true,
    mobileHasTitle: t("cars", {
      ns: "web_post_view"
    }),
    mobileNoLogo: true
  }, /*#__PURE__*/React.createElement("span", {
    className: ["m-show ", stl.mobileBack].join(" "),
    onClick: function onClick() {
      navigateTo('/');
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "".concat(CDN_LINK, "/assets/images/mobileBackBlueArr.svg"),
    alt: "back"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.content
  }, /*#__PURE__*/React.createElement("section", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("h1", {
    className: [stl.recommendationHeader, stl.mobileHide].join(' ')
  }, t('cars', {
    ns: 'web_common'
  }))), /*#__PURE__*/React.createElement("section", {
    className: stl.cardsContainer
  }, loading ? /*#__PURE__*/React.createElement(CarCardPlaceHolderGrid, {
    length: 20,
    columnWidth: 273
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: stl.cardsWrapper
  }, recommendationPosts.map(function (post, idx) {
    return /*#__PURE__*/React.createElement("li", {
      className: stl.card
    }, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      rank: idx + 1,
      page: 1,
      fromHomePage: true,
      referralLocation: "recommendation",
      sectionType: "recomended",
      onClick: function onClick() {
        var user_uuid = getCookieClient("UUID") || null;
        trackEvents("recommendation_car_clicked", {
          uuid: user_uuid || null,
          post_id: post.id,
          referral_location: "recommendation_list"
        });
      }
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: [stl.showRecommendedCarsSection].join(' ')
  }, /*#__PURE__*/React.createElement(Link, {
    to: createUrl("/filters"),
    className: stl.showAllRecommendedCarsButton
  }, t("see_cars", {
    ns: "web_common"
  }))))))));
};
export default RecommendationList;